export const timestampToDate = ({ unixNano }) => new Date(unixNano);
export const dateToTimestamp = (d) => ({ unixNano: d.getTime() });
